import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';
import * as moment from 'moment-timezone';
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-select-month-heat-map',
  templateUrl: './select-month-heat-map.component.html',
  styleUrls: ['./select-month-heat-map.component.scss']
})
export class SelectMonthHeatMapComponent implements OnInit {

  public items: any[] = [];
  public months: any = [this.gasprecioService.capitalizeFirstLetter(moment('2025-02-01').format('MMM YY'))];
  private lastMonthSelected: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService,
    private gasprecioService: GasprecioService
  ) { }

  ngOnInit(): void {
    const startDate = moment('2024-01-01');
    const endDate = moment().subtract(1, 'month').startOf('month');
    if(startDate < endDate) {
      const date = startDate.startOf('month');
      while (date <= endDate.endOf('month')) {
        this.items.push({
          name: this.gasprecioService.capitalizeFirstLetter(date.format('MMMM YY')),
          startDate: date.startOf('month').format('YYYY-MM-DD'),
          endDate: date.endOf('month').format('YYYY-MM-DD')
        });
        date.add(1, 'month');
      }
      this.items.reverse();
      this.months = [this.gasprecioService.capitalizeFirstLetter(endDate.format('MMMM YY'))];

      this.lastMonthSelected = this.sharedService.sharedSelectedMonth.subscribe((selectedMonth: string) => {
        this.months = selectedMonth
          ? this.gasprecioService.capitalizeFirstLetter(moment(selectedMonth, 'YYYY-MM-DD').format('MMMM YY'))
          : this.gasprecioService.capitalizeFirstLetter(endDate.format('MMMM YY'));
      });
    }
  }

  ngOnDestroy(): void {
    if (this.lastMonthSelected) {
      this.lastMonthSelected.unsubscribe();
    }
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  changeMonthsAgo(event: any) {
    this.months = event;
    this.items.map((e) => {
      if (e.name === event) {
        this.sharedService.nextSelectedMonth = e.startDate;
      }
    });
  }
}
